export default "__VITE_ASSET__DOfUM5pT__"